// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_kpi_res_values.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  StcsDisplayValueTypeEnum,
  stcsDisplayValueTypeEnumFromJSON,
  stcsDisplayValueTypeEnumToJSON,
} from "./stcs_enums.entity";

export const protobufPackage = "stcs_cmw";

/** v1.2.1 */
export interface StcsCompKpiResValues {
  id: string;
  version: string;
  meta: StcsCompKpiResValuesMeta | undefined;
  custom_map: { [key: string]: StcsCompKpiResValuesItem };
  growth_map: { [key: string]: StcsCompKpiResValuesItem };
  margin_map: { [key: string]: StcsCompKpiResValuesItem };
  nwc_map: { [key: string]: StcsCompKpiResValuesItem };
  debt_map: { [key: string]: StcsCompKpiResValuesItem };
  return_map: { [key: string]: StcsCompKpiResValuesItem };
  cf_map: { [key: string]: StcsCompKpiResValuesItem };
}

export interface StcsCompKpiResValues_CustomMapEntry {
  key: string;
  value: StcsCompKpiResValuesItem | undefined;
}

export interface StcsCompKpiResValues_GrowthMapEntry {
  key: string;
  value: StcsCompKpiResValuesItem | undefined;
}

export interface StcsCompKpiResValues_MarginMapEntry {
  key: string;
  value: StcsCompKpiResValuesItem | undefined;
}

export interface StcsCompKpiResValues_NwcMapEntry {
  key: string;
  value: StcsCompKpiResValuesItem | undefined;
}

export interface StcsCompKpiResValues_DebtMapEntry {
  key: string;
  value: StcsCompKpiResValuesItem | undefined;
}

export interface StcsCompKpiResValues_ReturnMapEntry {
  key: string;
  value: StcsCompKpiResValuesItem | undefined;
}

export interface StcsCompKpiResValues_CfMapEntry {
  key: string;
  value: StcsCompKpiResValuesItem | undefined;
}

export interface StcsCompKpiResValuesMeta {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  is_draft: boolean;
  fpna_begin_date_string: string;
  fpna_end_date_string: string;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
}

export interface StcsCompKpiResValuesItem {
  actuals_rv_map: { [key: string]: number };
  plan_rv_map: { [key: string]: number };
  /** Sort index for ordering in UI */
  sort_index: number;
  /** Display value type for UI representation, not 1:1 related to logic type */
  display_value_type: StcsDisplayValueTypeEnum;
}

export interface StcsCompKpiResValuesItem_ActualsRvMapEntry {
  key: string;
  value: number;
}

export interface StcsCompKpiResValuesItem_PlanRvMapEntry {
  key: string;
  value: number;
}

function createBaseStcsCompKpiResValues(): StcsCompKpiResValues {
  return {
    id: "",
    version: "",
    meta: undefined,
    custom_map: {},
    growth_map: {},
    margin_map: {},
    nwc_map: {},
    debt_map: {},
    return_map: {},
    cf_map: {},
  };
}

export const StcsCompKpiResValues: MessageFns<StcsCompKpiResValues> = {
  encode(message: StcsCompKpiResValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompKpiResValuesMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    Object.entries(message.custom_map).forEach(([key, value]) => {
      StcsCompKpiResValues_CustomMapEntry.encode({ key: key as any, value }, writer.uint32(162).fork()).join();
    });
    Object.entries(message.growth_map).forEach(([key, value]) => {
      StcsCompKpiResValues_GrowthMapEntry.encode({ key: key as any, value }, writer.uint32(170).fork()).join();
    });
    Object.entries(message.margin_map).forEach(([key, value]) => {
      StcsCompKpiResValues_MarginMapEntry.encode({ key: key as any, value }, writer.uint32(178).fork()).join();
    });
    Object.entries(message.nwc_map).forEach(([key, value]) => {
      StcsCompKpiResValues_NwcMapEntry.encode({ key: key as any, value }, writer.uint32(186).fork()).join();
    });
    Object.entries(message.debt_map).forEach(([key, value]) => {
      StcsCompKpiResValues_DebtMapEntry.encode({ key: key as any, value }, writer.uint32(194).fork()).join();
    });
    Object.entries(message.return_map).forEach(([key, value]) => {
      StcsCompKpiResValues_ReturnMapEntry.encode({ key: key as any, value }, writer.uint32(202).fork()).join();
    });
    Object.entries(message.cf_map).forEach(([key, value]) => {
      StcsCompKpiResValues_CfMapEntry.encode({ key: key as any, value }, writer.uint32(210).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompKpiResValuesMeta.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          const entry20 = StcsCompKpiResValues_CustomMapEntry.decode(reader, reader.uint32());
          if (entry20.value !== undefined) {
            message.custom_map[entry20.key] = entry20.value;
          }
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          const entry21 = StcsCompKpiResValues_GrowthMapEntry.decode(reader, reader.uint32());
          if (entry21.value !== undefined) {
            message.growth_map[entry21.key] = entry21.value;
          }
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          const entry22 = StcsCompKpiResValues_MarginMapEntry.decode(reader, reader.uint32());
          if (entry22.value !== undefined) {
            message.margin_map[entry22.key] = entry22.value;
          }
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          const entry23 = StcsCompKpiResValues_NwcMapEntry.decode(reader, reader.uint32());
          if (entry23.value !== undefined) {
            message.nwc_map[entry23.key] = entry23.value;
          }
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          const entry24 = StcsCompKpiResValues_DebtMapEntry.decode(reader, reader.uint32());
          if (entry24.value !== undefined) {
            message.debt_map[entry24.key] = entry24.value;
          }
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          const entry25 = StcsCompKpiResValues_ReturnMapEntry.decode(reader, reader.uint32());
          if (entry25.value !== undefined) {
            message.return_map[entry25.key] = entry25.value;
          }
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          const entry26 = StcsCompKpiResValues_CfMapEntry.decode(reader, reader.uint32());
          if (entry26.value !== undefined) {
            message.cf_map[entry26.key] = entry26.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompKpiResValuesMeta.fromJSON(object.meta) : undefined,
      custom_map: isObject(object.custom_map)
        ? Object.entries(object.custom_map).reduce<{ [key: string]: StcsCompKpiResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      growth_map: isObject(object.growth_map)
        ? Object.entries(object.growth_map).reduce<{ [key: string]: StcsCompKpiResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      margin_map: isObject(object.margin_map)
        ? Object.entries(object.margin_map).reduce<{ [key: string]: StcsCompKpiResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      nwc_map: isObject(object.nwc_map)
        ? Object.entries(object.nwc_map).reduce<{ [key: string]: StcsCompKpiResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      debt_map: isObject(object.debt_map)
        ? Object.entries(object.debt_map).reduce<{ [key: string]: StcsCompKpiResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      return_map: isObject(object.return_map)
        ? Object.entries(object.return_map).reduce<{ [key: string]: StcsCompKpiResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      cf_map: isObject(object.cf_map)
        ? Object.entries(object.cf_map).reduce<{ [key: string]: StcsCompKpiResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompKpiResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompKpiResValues): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompKpiResValuesMeta.toJSON(message.meta);
    }
    if (message.custom_map) {
      const entries = Object.entries(message.custom_map);
      if (entries.length > 0) {
        obj.custom_map = {};
        entries.forEach(([k, v]) => {
          obj.custom_map[k] = StcsCompKpiResValuesItem.toJSON(v);
        });
      }
    }
    if (message.growth_map) {
      const entries = Object.entries(message.growth_map);
      if (entries.length > 0) {
        obj.growth_map = {};
        entries.forEach(([k, v]) => {
          obj.growth_map[k] = StcsCompKpiResValuesItem.toJSON(v);
        });
      }
    }
    if (message.margin_map) {
      const entries = Object.entries(message.margin_map);
      if (entries.length > 0) {
        obj.margin_map = {};
        entries.forEach(([k, v]) => {
          obj.margin_map[k] = StcsCompKpiResValuesItem.toJSON(v);
        });
      }
    }
    if (message.nwc_map) {
      const entries = Object.entries(message.nwc_map);
      if (entries.length > 0) {
        obj.nwc_map = {};
        entries.forEach(([k, v]) => {
          obj.nwc_map[k] = StcsCompKpiResValuesItem.toJSON(v);
        });
      }
    }
    if (message.debt_map) {
      const entries = Object.entries(message.debt_map);
      if (entries.length > 0) {
        obj.debt_map = {};
        entries.forEach(([k, v]) => {
          obj.debt_map[k] = StcsCompKpiResValuesItem.toJSON(v);
        });
      }
    }
    if (message.return_map) {
      const entries = Object.entries(message.return_map);
      if (entries.length > 0) {
        obj.return_map = {};
        entries.forEach(([k, v]) => {
          obj.return_map[k] = StcsCompKpiResValuesItem.toJSON(v);
        });
      }
    }
    if (message.cf_map) {
      const entries = Object.entries(message.cf_map);
      if (entries.length > 0) {
        obj.cf_map = {};
        entries.forEach(([k, v]) => {
          obj.cf_map[k] = StcsCompKpiResValuesItem.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues>, I>>(base?: I): StcsCompKpiResValues {
    return StcsCompKpiResValues.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues>, I>>(object: I): StcsCompKpiResValues {
    const message = createBaseStcsCompKpiResValues();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompKpiResValuesMeta.fromPartial(object.meta)
      : undefined;
    message.custom_map = Object.entries(object.custom_map ?? {}).reduce<{ [key: string]: StcsCompKpiResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.growth_map = Object.entries(object.growth_map ?? {}).reduce<{ [key: string]: StcsCompKpiResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.margin_map = Object.entries(object.margin_map ?? {}).reduce<{ [key: string]: StcsCompKpiResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.nwc_map = Object.entries(object.nwc_map ?? {}).reduce<{ [key: string]: StcsCompKpiResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.debt_map = Object.entries(object.debt_map ?? {}).reduce<{ [key: string]: StcsCompKpiResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.return_map = Object.entries(object.return_map ?? {}).reduce<{ [key: string]: StcsCompKpiResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.cf_map = Object.entries(object.cf_map ?? {}).reduce<{ [key: string]: StcsCompKpiResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompKpiResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsCompKpiResValues_CustomMapEntry(): StcsCompKpiResValues_CustomMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiResValues_CustomMapEntry: MessageFns<StcsCompKpiResValues_CustomMapEntry> = {
  encode(message: StcsCompKpiResValues_CustomMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues_CustomMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues_CustomMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues_CustomMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiResValues_CustomMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues_CustomMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValues_CustomMapEntry {
    return StcsCompKpiResValues_CustomMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues_CustomMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValues_CustomMapEntry {
    const message = createBaseStcsCompKpiResValues_CustomMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiResValues_GrowthMapEntry(): StcsCompKpiResValues_GrowthMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiResValues_GrowthMapEntry: MessageFns<StcsCompKpiResValues_GrowthMapEntry> = {
  encode(message: StcsCompKpiResValues_GrowthMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues_GrowthMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues_GrowthMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues_GrowthMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiResValues_GrowthMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues_GrowthMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValues_GrowthMapEntry {
    return StcsCompKpiResValues_GrowthMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues_GrowthMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValues_GrowthMapEntry {
    const message = createBaseStcsCompKpiResValues_GrowthMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiResValues_MarginMapEntry(): StcsCompKpiResValues_MarginMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiResValues_MarginMapEntry: MessageFns<StcsCompKpiResValues_MarginMapEntry> = {
  encode(message: StcsCompKpiResValues_MarginMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues_MarginMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues_MarginMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues_MarginMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiResValues_MarginMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues_MarginMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValues_MarginMapEntry {
    return StcsCompKpiResValues_MarginMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues_MarginMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValues_MarginMapEntry {
    const message = createBaseStcsCompKpiResValues_MarginMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiResValues_NwcMapEntry(): StcsCompKpiResValues_NwcMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiResValues_NwcMapEntry: MessageFns<StcsCompKpiResValues_NwcMapEntry> = {
  encode(message: StcsCompKpiResValues_NwcMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues_NwcMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues_NwcMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues_NwcMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiResValues_NwcMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues_NwcMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValues_NwcMapEntry {
    return StcsCompKpiResValues_NwcMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues_NwcMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValues_NwcMapEntry {
    const message = createBaseStcsCompKpiResValues_NwcMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiResValues_DebtMapEntry(): StcsCompKpiResValues_DebtMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiResValues_DebtMapEntry: MessageFns<StcsCompKpiResValues_DebtMapEntry> = {
  encode(message: StcsCompKpiResValues_DebtMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues_DebtMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues_DebtMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues_DebtMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiResValues_DebtMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues_DebtMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValues_DebtMapEntry {
    return StcsCompKpiResValues_DebtMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues_DebtMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValues_DebtMapEntry {
    const message = createBaseStcsCompKpiResValues_DebtMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiResValues_ReturnMapEntry(): StcsCompKpiResValues_ReturnMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiResValues_ReturnMapEntry: MessageFns<StcsCompKpiResValues_ReturnMapEntry> = {
  encode(message: StcsCompKpiResValues_ReturnMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues_ReturnMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues_ReturnMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues_ReturnMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiResValues_ReturnMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues_ReturnMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValues_ReturnMapEntry {
    return StcsCompKpiResValues_ReturnMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues_ReturnMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValues_ReturnMapEntry {
    const message = createBaseStcsCompKpiResValues_ReturnMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiResValues_CfMapEntry(): StcsCompKpiResValues_CfMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompKpiResValues_CfMapEntry: MessageFns<StcsCompKpiResValues_CfMapEntry> = {
  encode(message: StcsCompKpiResValues_CfMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompKpiResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValues_CfMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValues_CfMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompKpiResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValues_CfMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompKpiResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompKpiResValues_CfMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompKpiResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValues_CfMapEntry>, I>>(base?: I): StcsCompKpiResValues_CfMapEntry {
    return StcsCompKpiResValues_CfMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValues_CfMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValues_CfMapEntry {
    const message = createBaseStcsCompKpiResValues_CfMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompKpiResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompKpiResValuesMeta(): StcsCompKpiResValuesMeta {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    is_draft: false,
    fpna_begin_date_string: "",
    fpna_end_date_string: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
  };
}

export const StcsCompKpiResValuesMeta: MessageFns<StcsCompKpiResValuesMeta> = {
  encode(message: StcsCompKpiResValuesMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.is_draft !== false) {
      writer.uint32(32).bool(message.is_draft);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(42).string(message.fpna_begin_date_string);
    }
    if (message.fpna_end_date_string !== "") {
      writer.uint32(50).string(message.fpna_end_date_string);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(58).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(66).string(message.obj_updated_iso_utc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValuesMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValuesMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_end_date_string = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValuesMeta {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
      fpna_end_date_string: isSet(object.fpna_end_date_string) ? globalThis.String(object.fpna_end_date_string) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
    };
  },

  toJSON(message: StcsCompKpiResValuesMeta): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    if (message.fpna_end_date_string !== "") {
      obj.fpna_end_date_string = message.fpna_end_date_string;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValuesMeta>, I>>(base?: I): StcsCompKpiResValuesMeta {
    return StcsCompKpiResValuesMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValuesMeta>, I>>(object: I): StcsCompKpiResValuesMeta {
    const message = createBaseStcsCompKpiResValuesMeta();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.is_draft = object.is_draft ?? false;
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    message.fpna_end_date_string = object.fpna_end_date_string ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    return message;
  },
};

function createBaseStcsCompKpiResValuesItem(): StcsCompKpiResValuesItem {
  return { actuals_rv_map: {}, plan_rv_map: {}, sort_index: 0, display_value_type: 0 };
}

export const StcsCompKpiResValuesItem: MessageFns<StcsCompKpiResValuesItem> = {
  encode(message: StcsCompKpiResValuesItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.actuals_rv_map).forEach(([key, value]) => {
      StcsCompKpiResValuesItem_ActualsRvMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    Object.entries(message.plan_rv_map).forEach(([key, value]) => {
      StcsCompKpiResValuesItem_PlanRvMapEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    if (message.sort_index !== 0) {
      writer.uint32(24).uint32(message.sort_index);
    }
    if (message.display_value_type !== 0) {
      writer.uint32(32).int32(message.display_value_type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValuesItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValuesItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsCompKpiResValuesItem_ActualsRvMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.actuals_rv_map[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = StcsCompKpiResValuesItem_PlanRvMapEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.plan_rv_map[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sort_index = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.display_value_type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValuesItem {
    return {
      actuals_rv_map: isObject(object.actuals_rv_map)
        ? Object.entries(object.actuals_rv_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      plan_rv_map: isObject(object.plan_rv_map)
        ? Object.entries(object.plan_rv_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      sort_index: isSet(object.sort_index) ? globalThis.Number(object.sort_index) : 0,
      display_value_type: isSet(object.display_value_type)
        ? stcsDisplayValueTypeEnumFromJSON(object.display_value_type)
        : 0,
    };
  },

  toJSON(message: StcsCompKpiResValuesItem): unknown {
    const obj: any = {};
    if (message.actuals_rv_map) {
      const entries = Object.entries(message.actuals_rv_map);
      if (entries.length > 0) {
        obj.actuals_rv_map = {};
        entries.forEach(([k, v]) => {
          obj.actuals_rv_map[k] = v;
        });
      }
    }
    if (message.plan_rv_map) {
      const entries = Object.entries(message.plan_rv_map);
      if (entries.length > 0) {
        obj.plan_rv_map = {};
        entries.forEach(([k, v]) => {
          obj.plan_rv_map[k] = v;
        });
      }
    }
    if (message.sort_index !== 0) {
      obj.sort_index = Math.round(message.sort_index);
    }
    if (message.display_value_type !== 0) {
      obj.display_value_type = stcsDisplayValueTypeEnumToJSON(message.display_value_type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValuesItem>, I>>(base?: I): StcsCompKpiResValuesItem {
    return StcsCompKpiResValuesItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValuesItem>, I>>(object: I): StcsCompKpiResValuesItem {
    const message = createBaseStcsCompKpiResValuesItem();
    message.actuals_rv_map = Object.entries(object.actuals_rv_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.plan_rv_map = Object.entries(object.plan_rv_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.sort_index = object.sort_index ?? 0;
    message.display_value_type = object.display_value_type ?? 0;
    return message;
  },
};

function createBaseStcsCompKpiResValuesItem_ActualsRvMapEntry(): StcsCompKpiResValuesItem_ActualsRvMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompKpiResValuesItem_ActualsRvMapEntry: MessageFns<StcsCompKpiResValuesItem_ActualsRvMapEntry> = {
  encode(message: StcsCompKpiResValuesItem_ActualsRvMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValuesItem_ActualsRvMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValuesItem_ActualsRvMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValuesItem_ActualsRvMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompKpiResValuesItem_ActualsRvMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValuesItem_ActualsRvMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValuesItem_ActualsRvMapEntry {
    return StcsCompKpiResValuesItem_ActualsRvMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValuesItem_ActualsRvMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValuesItem_ActualsRvMapEntry {
    const message = createBaseStcsCompKpiResValuesItem_ActualsRvMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseStcsCompKpiResValuesItem_PlanRvMapEntry(): StcsCompKpiResValuesItem_PlanRvMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompKpiResValuesItem_PlanRvMapEntry: MessageFns<StcsCompKpiResValuesItem_PlanRvMapEntry> = {
  encode(message: StcsCompKpiResValuesItem_PlanRvMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompKpiResValuesItem_PlanRvMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompKpiResValuesItem_PlanRvMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompKpiResValuesItem_PlanRvMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompKpiResValuesItem_PlanRvMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompKpiResValuesItem_PlanRvMapEntry>, I>>(
    base?: I,
  ): StcsCompKpiResValuesItem_PlanRvMapEntry {
    return StcsCompKpiResValuesItem_PlanRvMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompKpiResValuesItem_PlanRvMapEntry>, I>>(
    object: I,
  ): StcsCompKpiResValuesItem_PlanRvMapEntry {
    const message = createBaseStcsCompKpiResValuesItem_PlanRvMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
